import { jsx as _jsx } from "react/jsx-runtime";
import { getMemberPaymentCards } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-member-payment-card-wallet');
export const MemberPaymentCardWalletSkeleton = observer(() => {
    var _a;
    const numberOfCards = ((_a = getMemberPaymentCards()) === null || _a === void 0 ? void 0 : _a.length) || 1;
    const skeletonCards = [];
    // Add an extra skeleton card for the Add button
    for (let i = 0; i < numberOfCards + 1; i++) {
        skeletonCards.push(_jsx("div", { className: b.element('card', { skeleton: true }) }, `skeleton-card__${i}`));
    }
    return _jsx("div", Object.assign({ className: b.block() }, { children: skeletonCards }));
});
MemberPaymentCardWalletSkeleton.displayName = 'MemberPaymentCardWalletSkeleton';
